export const FONT_BODY = '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
export const FONT_DISPLAY = '"Outfit", "Inter", system-ui, -apple-system, sans-serif';
export const FONT_MONO = '"Space Mono", ui-monospace, SFMono-Regular, Menlo, monospace';

export const brand = {
  navy900: '#070F1E',
  navy850: '#0A1322',
  navy800: '#0D1729',
  navy700: '#16223A',
  blue: '#4C60C9',
  blueLight: '#8BACFF',
  blueSoft: '#9FB4E6',
  lime: '#D0F440',
  limeDeep: '#C8E838',
  green: '#1EC260',
  red: '#E4002B',
  ink: '#0F1A2E',
} as const;

export const darkTokens = {
  background: {
    default: brand.navy900,
    paper: brand.navy800,
    elevated: brand.navy700,
  },
  text: {
    primary: '#E4EDFF',
    secondary: brand.blueLight,
    disabled: '#5E74B0',
  },
  divider: 'rgba(139, 172, 255, 0.12)',
  dividerSolid: '#1D2A44',
  actionDisabled: 'rgba(228, 237, 255, 0.30)',
  accent: { main: brand.lime, contrastText: brand.ink },
} as const;

export const lightTokens = {
  background: {
    default: '#F5F7FC',
    paper: '#FFFFFF',
    elevated: '#EEF1F9',
  },
  text: {
    primary: brand.ink,
    secondary: '#55618A',
    disabled: '#9AA3C0',
  },
  divider: 'rgba(15, 26, 46, 0.10)',
  dividerSolid: '#E2E7F3',
  actionDisabled: 'rgba(15, 26, 46, 0.26)',
  accent: { main: brand.limeDeep, contrastText: brand.ink },
} as const;

declare module '@mui/material/styles' {
  interface Palette {
    accent: Palette['primary'];
  }
  interface PaletteOptions {
    accent?: PaletteOptions['primary'];
  }
}
